(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminJobEditSettingsController', AdminJobEditSettingsController);

    function AdminJobEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'job_acceptance_terms_file',
                'job_acceptance_terms_text',
                'job_satisfaction_survey_frequency',
                'job_group_child_select_mandatory',
                'allow_secondary_approvers_to_reopen_jobs',
                'job_reporter_feedback',
                'job_complete_email_text'
            ],
            elbSettings: elbSettings,
            module: module,
            modulesService: modulesService,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: (vm) => ({
                'job_acceptance_terms_file' : {
                    type: 'file',
                    downloadTitle: 'TERMS_DOWNLOAD_TITLE',
                    downloadHref: vm.settings && vm.settings.job_acceptance_terms_file
                        ? vm.settings.job_acceptance_terms_file.value
                        : null,
                    fileName: vm.settings && vm.settings.job_acceptance_terms_file
                        ? vm.settings.job_acceptance_terms_file.filename
                        : null
                },
                'job_acceptance_terms_text' : { type: 'cke-editor', rows: 5 },
                'job_satisfaction_survey_frequency': { type: 'number', options: { invalid: false} },
                'job_group_child_select_mandatory': { type: 'checkbox' },
                'allow_secondary_approvers_to_reopen_jobs': { type: 'checkbox' },
                'job_reporter_feedback': { type: 'checkbox' },
                'job_complete_email_text': { type: 'cke-editor', rows: 5, subLabel: 'ADDITIONAL_TEXT_JOB_COMPLETION_EMAILS' }
            })
        });

        angular.extend(vm, base);
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
    }
})();
